const MobileMediaGalleryUX = () => {
    if ($('.mobile-media-gallery, .mobile-product-media-gallery').length <= 0) return null;
    
    //media-gallery
    const $mgGallery = $('.mobile-media-gallery, .mobile-product-media-gallery');
    $mgGallery.each(function() {
        const $mgSlider = $(this).find('.mmg-slider');
        const $mgSliderPrev = $(this).find('.custom-slider-arrow.prev');
        const $mgSliderNext = $(this).find('.custom-slider-arrow.next');
        const $mgIndicator = $(this).find('.product-media-indicator .current-iteration');
    
        const slickOptions = {
            slidesToShow: 1,
            slidesToScroll: 1,
            ininite: true,
            dots: false,
            arrows: true,
            prevArrow: $mgSliderPrev,
            nextArrow: $mgSliderNext,
            rows: 0,
            autoplay: true,
            autoplaySpeed: 4000,
            centerMode: true,
            centerPadding: '30px'
        }
    
        
        if ($mgSlider.length > 0) {
            $mgSlider.slick(slickOptions);
            $mgSlider.on('afterChange', function(event, slick, currentSlide) {
                $mgIndicator.text(currentSlide + 1);
            })
        }
        
        $('a[href^="#mg-popup"]').click(function() {
            const popupId = $(this).data('zoom-popup-id');
            let html = $(this).next('.popup-html-append').html();

            $(`#mg-popup-${popupId} .html-inner`).empty();
            $(`#mg-popup-${popupId} .html-inner`).html(html);
        });

        $('a[href^="#mg-popup"]').magnificPopup({
            type: 'inline',
            midClick: true,
        })
    })
}

export default MobileMediaGalleryUX